import "../assets/index-2a8e4ca1.css";
import n from "./NcPopover.mjs";
import c from "./NcTextField.mjs";
import { t as r } from "../chunks/l10n-1b905a9a.mjs";
import { Emoji as l, Picker as u, EmojiIndex as f } from "emoji-mart-vue-fast";
import p from "emoji-mart-vue-fast/data/all.json";
import { n as m } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
let o;
const d = {
  search: r("Search emoji"),
  notfound: r("No emoji found"),
  categories: {
    search: r("Search results"),
    recent: r("Frequently used"),
    smileys: r("Smileys & Emotion"),
    people: r("People & Body"),
    nature: r("Animals & Nature"),
    foods: r("Food & Drink"),
    activity: r("Activities"),
    places: r("Travel & Places"),
    objects: r("Objects"),
    symbols: r("Symbols"),
    flags: r("Flags"),
    custom: r("Custom")
  }
}, h = {
  name: "NcEmojiPicker",
  components: {
    NcPopover: n,
    NcTextField: c,
    Emoji: l,
    Picker: u
  },
  props: {
    /**
     * The emoji-set
     */
    activeSet: {
      type: String,
      default: "native"
    },
    /**
     * Show preview section when hovering emoji
     */
    showPreview: {
      type: Boolean,
      default: !1
    },
    /**
     * Allow unselecting the selected emoji
     */
    allowUnselect: {
      type: Boolean,
      default: !1
    },
    /**
     * Selected emoji to allow unselecting
     */
    selectedEmoji: {
      type: String,
      default: ""
    },
    /**
     * The fallback emoji in the preview section
     */
    previewFallbackEmoji: {
      type: String,
      default: "grinning"
    },
    /**
     * The fallback text in the preview section
     */
    previewFallbackName: {
      type: String,
      default: r("Pick an emoji")
    },
    /**
     * Whether to close the emoji picker after picking one
     */
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Selector for the popover container
     */
    container: {
      type: [String, Object, Element, Boolean],
      default: "body"
    }
  },
  emits: [
    "select",
    "select-data",
    "unselect"
  ],
  setup() {
    return o || (o = new f(p)), {
      // Non-reactive constants
      emojiIndex: o,
      i18n: d
    };
  },
  data() {
    return {
      search: "",
      open: !1
    };
  },
  computed: {
    native() {
      return this.activeSet === "native";
    }
  },
  methods: {
    t: r,
    clearSearch() {
      var e, t;
      this.search = "";
      const i = (t = (e = this.$refs.search) == null ? void 0 : e.$refs.inputField) == null ? void 0 : t.$refs.input;
      i && i.focus();
    },
    select(i) {
      this.$emit("select", i.native), this.$emit("select-data", i), this.closeOnSelect && (this.open = !1);
    },
    unselect() {
      this.$emit("unselect");
    },
    afterShow() {
      var t, s;
      this.$refs.picker.$el.addEventListener("keydown", this.checkKeyEvent);
      const e = (s = (t = this.$refs.search) == null ? void 0 : t.$refs.inputField) == null ? void 0 : s.$refs.input;
      e && e.focus();
    },
    afterHide() {
      this.$refs.picker.$el.removeEventListener("keydown", this.checkKeyEvent);
    },
    checkKeyEvent(i) {
      if (i.key !== "Tab")
        return;
      const t = this.$refs.picker.$el.querySelectorAll(
        "button, input"
      ), s = t.length - 1;
      if (t.length <= 1) {
        i.preventDefault();
        return;
      }
      i.shiftKey === !1 && i.target === t[s] ? (i.preventDefault(), t[0].focus()) : i.shiftKey === !0 && i.target === t[0] && (i.preventDefault(), t[s].focus());
    }
  }
};
var v = function() {
  var e = this, t = e._self._c;
  return t("NcPopover", e._g(e._b({ attrs: { shown: e.open, container: e.container }, on: { "update:shown": function(s) {
    e.open = s;
  }, "after-show": e.afterShow, "after-hide": e.afterHide }, scopedSlots: e._u([{ key: "trigger", fn: function() {
    return [e._t("default")];
  }, proxy: !0 }], null, !0) }, "NcPopover", e.$attrs, !1), e.$listeners), [t("Picker", e._b({ ref: "picker", attrs: { "auto-focus": !1, color: "var(--color-primary-element)", data: e.emojiIndex, emoji: e.previewFallbackEmoji, i18n: e.i18n, native: e.native, "emoji-size": 20, "per-line": 8, "picker-styles": { width: "320px" }, "show-preview": e.showPreview, title: e.previewFallbackName }, on: { select: e.select }, scopedSlots: e._u([{ key: "searchTemplate", fn: function(s) {
    return [t("NcTextField", { ref: "search", staticClass: "search", attrs: { value: e.search, label: e.t("Search"), "label-visible": !0, placeholder: e.i18n.search, "trailing-button-icon": "close", "trailing-button-label": e.t("Clear search"), "show-trailing-button": e.search !== "" }, on: { "update:value": [function(a) {
      e.search = a;
    }, function(a) {
      return s.onSearch(e.search);
    }], "trailing-button-click": function(a) {
      e.clearSearch(), s.onSearch(e.search);
    } } })];
  } }, e.allowUnselect && e.selectedEmoji ? { key: "customCategory", fn: function() {
    return [t("div", { staticClass: "emoji-mart-category-label" }, [t("h3", { staticClass: "emoji-mart-category-label" }, [e._v(" " + e._s(e.t("Selected")) + " ")])]), t("Emoji", { staticClass: "emoji-selected", attrs: { data: e.emojiIndex, emoji: e.selectedEmoji, native: !0, size: 32 }, on: { click: e.unselect } }), t("Emoji", { staticClass: "emoji-delete", attrs: { data: e.emojiIndex, emoji: ":x:", native: !0, size: 10 }, on: { click: e.unselect } })];
  }, proxy: !0 } : null], null, !0) }, "Picker", e.$attrs, !1))], 1);
}, y = [], _ = /* @__PURE__ */ m(
  h,
  v,
  y,
  !1,
  null,
  "4d56e499",
  null,
  null
);
const $ = _.exports;
export {
  $ as default
};
